import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import moment from "moment";

@Component({
    selector: 'app-child-date-cell',
    template: `
    <span *ngIf="!showLink">{{data}}</span>
    <a href="javascript:void(0)" (click)="createEdit()" *ngIf="showLink">{{data}}</a>
  `,
    styles: [],
    standalone: false
})

export class DateRendererComponent implements ICellRendererAngularComp {
  params: any;
  data: any;
  rowIndex: any;
  showLink = false;

  agInit(params: any): void {
    this.params = params;
    this.data = params.data.effectiveDate ? moment(params.data.effectiveDate).format('MM/DD/YYYY') : '';
    this.rowIndex = params.rowIndex;
    this.showLink = params.data.businessType === 'FRT' && params.node.rowIndex === params.api.getDisplayedRowCount() - 1;
  }

  createEdit() {
    this.params.onClick(this.params.data);
  }

  refresh(): boolean {
    return false;
  }
}
